import type * as Quote from '../types/Quote'
import { imageParser } from '../props/parsers/Image'

export default function quoteComponentParser(
  rawComponent: Quote.Raw,
): Quote.Parsed {
  const [
    { image, quoteeText, quoteeTitle, ...rest },
  ] = rawComponent.fullWidthQuote

  let props = {
    authorText: quoteeText,
    credentialsText: quoteeTitle,
    ...rest,
  }

  if (image) {
    props = {
      ...props,
      ...imageParser(image),
    }
  }

  return {
    name: 'Quote',
    props,
  }
}
